module.exports = __webpack_public_path__ + "media/images/front/icons_logout-3438d5ff713bfe867abedcd1f9880758.png";